module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand17-3a50ae4aa09ad69c4c28ce72fcc43b55.jpg";